import { useI18n } from "@/i18n/I18nContext";
import { normalizePreferredLang } from "@/lib/i18n/tri-language";

/**
 * Phase CL — global Language & Meanings settings (preferred language + display toggles).
 */
export function useLanguageSettings() {
  const { lang, setLang, triSettings, updateTriSettings } = useI18n();

  return {
    preferredLanguage: normalizePreferredLang(lang),
    showEnglish: triSettings?.showEnglish !== false,
    showSanskrit: triSettings?.showSanskrit !== false,
    setLanguageSettings: (patch) => {
      if (patch?.preferredLanguage) setLang(patch.preferredLanguage);
      updateTriSettings(patch);
    },
    setPreferredLanguage: setLang,
    updateTriSettings,
    triSettings,
  };
}
